import React from 'react';

/**
 * ARISE brand lockup — product wordmark ("ARISE") paired with the geometric
 * /tmp Labs "TF" mark. Ties the product to its maker (/tmp Labs).
 *
 * Variants (background-aware):
 * | variant | mark        | text        | use on                    |
 * |---------|-------------|-------------|---------------------------|
 * | light   | teal mark   | dark text   | white / light backgrounds |
 * | dark    | white mark  | white text  | dark / gradient surfaces  |
 *
 * The mark PNGs live in public/brand/ (served at /brand/*). Teal is the
 * official /tmp Labs brand color (emerald/teal is logo-only per DESIGN.md).
 */

const MARKS = {
  light: '/brand/tmplabs-mark-teal.png',
  dark: '/brand/tmplabs-mark-white.png',
};

const MARK_SIZES = {
  sm: 'h-7 w-7',
  md: 'h-9 w-9',
  lg: 'h-11 w-11',
};

const WORDMARK_SIZES = {
  sm: 'text-base',
  md: 'text-lg',
  lg: 'text-2xl',
};

const AriseBrand = ({
  variant = 'light',
  size = 'md',
  showByline = true,
  className = '',
  onClick,
}) => {
  const dark = variant === 'dark';
  return (
    <div
      className={`flex items-center gap-3 ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
    >
      <img
        src={MARKS[variant] || MARKS.light}
        alt="/tmp Labs"
        className={`${MARK_SIZES[size] || MARK_SIZES.md} object-contain shrink-0`}
      />
      <div className="leading-none">
        <span
          className={`block font-bold tracking-tight ${WORDMARK_SIZES[size] || WORDMARK_SIZES.md} ${
            dark ? 'text-white' : 'text-ink'
          }`}
        >
          ARISE
        </span>
        {showByline && (
          <span
            className={`block text-[11px] font-medium mt-0.5 ${
              dark ? 'text-gray-400' : 'text-ink-subtle'
            }`}
          >
            by /tmp Labs
          </span>
        )}
      </div>
    </div>
  );
};

export { AriseBrand };
export default AriseBrand;
